import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { ComponentBase } from 'src/app/views/component-base';
import { AppState } from 'src/app/store/app.states';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    imports: [
        NgClass,
        MatIcon,
    ],
})
export class BannerComponent
    extends ComponentBase
    implements OnInit, OnDestroy {

    @Input() set type(value: 'info' | 'danger' | 'success' | 'warning') {
        this._type = value;
        switch(value){
            case 'info':
                this._icon = 'notifications';
                break;
            case 'danger':
                this._icon = 'report'
                break;
            case 'success':
                this._icon = 'check';
                break;
            case 'warning':
                this._icon = 'warning';
                break;
            default:
                break;
        }
    }

    _type: string = 'info';
    _icon:string = 'notifications';

    constructor(public store: Store<AppState>) {
        super();
    }

    ngOnInit() {
        super.ngOnInitBase();
    }

    ngOnDestroy() {
        super.ngOnDestroyBase();
    }
}
